import {Injectable} from "@angular/core";
import {UtilService} from "@app/modules/shared/services/util.service";

declare const moment;

@Injectable()
export class ConvertIsoDateService {
  year: string;
  month: string;
  day: string;
  hour: string;
  minute: string;
  second: string;
  fullDate: string;

  momentFormat = "YYYY-MM-DD HH:mm:ss";
  dateFormatString = UtilService.dateFormatString + " HH:mm:ss";

  constructor() {}

  getGMT = (date: Date): string => date.toTimeString().split(" ")[1];

  utcToLocalDate(date) {
    let timestamp: number;
    if (typeof date === "number") {
      timestamp = date;
    } else if (typeof date === "string") {
      timestamp = new Date(date).getTime();
    } else if (typeof date === Date()) {
      timestamp = date.getTime();
    } else {
      return;
    }
    const utcDate = moment
      .unix(timestamp / 1000)
      .utc()
      .format(this.momentFormat);
    const local = moment.utc(utcDate).local().format(this.momentFormat);
    return new Date(moment.utc(local).local().format(this.momentFormat));
  }

  localToUtc(date, dateFormat = false) {
    let timestamp: number;
    if (typeof date === "number") {
      timestamp = date;
    } else if (typeof date === "string") {
      timestamp = new Date(date).getTime();
    } else if (typeof date === Date()) {
      timestamp = date.getTime();
    } else {
      return;
    }
    return moment
      .unix(timestamp / 1000)
      .utc()
      .format(this.dateFormatString);
  }

  localDate(date, dateFormat = false) {
    return moment
      .parseZone(moment(date, this.momentFormat))
      .local()
      .format(dateFormat ? this.dateFormatString : this.momentFormat);
  }

  localDateTimestamp(date) {
    return moment(this.localDate(date), this.momentFormat).valueOf();
  }

  // gelen tarihi utc formatına çeviriyor (tarih ve saat birlikte)
  utcDate(date, dateFormat = false) {
    return moment
      .parseZone(moment(date, this.momentFormat))
      .utc()
      .format(dateFormat ? this.dateFormatString : this.momentFormat);
  }

  // gelen tarihi utc timestamp formatına çeviriyor (tarih ve saat birlikte)
  utcDateTimestamp(date) {
    return moment(this.utcDate(date), this.momentFormat).valueOf();
  }

  // gelen tarihi yıl-ay-gün şeklinde geri dönüyor (saatsiz)
  public convertDate(date: any) {
    this.year = date.getFullYear();
    if (date.getMonth() < 9) {
      // tslint:disable-next-line:radix
      this.month = "0" + (parseInt(date.getMonth()) + 1).toString();
    } else {
      // tslint:disable-next-line:radix
      this.month = (parseInt(date.getMonth()) + 1).toString();
    }
    if (date.getDate() < 10) {
      this.day = "0" + date.getDate();
    } else {
      this.day = date.getDate();
    }
    return (this.fullDate = this.year + "-" + this.month + "-" + this.day);
  }

  public convertDateAndTime(date: any, dateFormat?) {
    if (date.getHours() < 10) {
      this.hour = "0" + date.getHours();
    } else {
      this.hour = date.getHours();
    }
    if (date.getMinutes() < 10) {
      this.minute = "0" + date.getMinutes();
    } else {
      this.minute = date.getMinutes();
    }
    if (date.getMinutes() < 10) {
      this.second = "0" + date.getSeconds();
    } else {
      this.second = date.getSeconds();
    }
    const dateISO = date.toLocaleString().split(" ");
    return (this.fullDate = this.makeDate(date, dateFormat) + " " + dateISO[1]);
  }

  makeDate = (date: Date, dateFormat?) => {
    dateFormat = dateFormat ? dateFormat : "YYYY-MM-DD";
    const year = date.getFullYear();
    let month, day, fullDate;
    if (date.getMonth() < 9) {
      month = "0" + (date.getMonth() + 1);
    } else {
      month = date.getMonth() + 1;
    }
    if (date.getDate() < 10) {
      day = "0" + date.getDate();
    } else {
      day = date.getDate();
    }
    switch (dateFormat.toLowerCase()) {
      case "dd.mm.yyyy":
        fullDate = day + "." + month + "." + year;
        break;
      case "dd-mm-yyyy":
        fullDate = day + "-" + month + "-" + year;
        break;
      case "dd/mm/yyyy":
        fullDate = month + "/" + day + "/" + year;
        break;
      case "mm.dd.yyyy":
        fullDate = month + "-" + day + "-" + year;
        break;
      case "mm-dd-yyyy":
        fullDate = month + "." + day + "." + year;
        break;
      case "mm/dd/yyyy":
        fullDate = month + "/" + day + "/" + year;
        break;
      case "yyyy.mm.dd":
        fullDate = year + "." + month + "." + day;
        break;
      case "yyyy-mm-dd":
        fullDate = year + "-" + month + "-" + day;
        break;
      case "yyyy/mm/dd":
        fullDate = year + "/" + month + "/" + day;
        break;
      case "d/mm/yyyy":
        fullDate = month + "/" + day + "/" + year;
        break;
      default:
        fullDate = year + "/" + month + "/" + day;
        break;
    }
    return fullDate;
  };
}
